import { io } from 'socket.io-client';
import { useEffect, useState } from 'react';

export function useNotificationSocket(token) {
  const apiUrl = process.env.REACT_APP_BACKEND_API;
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!token) return;

    const s = io(apiUrl, {
      auth: { token },
    });

    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, [token]);

  return socket;
}
